import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import {
  getTodayDate,
  // validateName,
  validateRequired,
} from "../../../../common/Validations";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useSelector } from "react-redux";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  VALID_BANK_ACC: "validate banck account number",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  DOC_NUMBER: "Invalid Document Number",
};

const CreditPolicyRequestFormOrderBookingModal = React.forwardRef(
  (props, ref) => {
    const [isCardVisible1, setCardVisible1] = useState(true);
    const [isCardVisible2, setCardVisible2] = useState(true);
    const [getDropdownData, setDropdownData] = useState("");

    const [getdisabled, setDisabled] = useState(false);

    // const creditLimitExceedCustomerDropdown = [
    //   { id: 1, name: "Limit" },
    //   { id: 1, name: "Period" },
    // ];

    let userData = useSelector((state) => state?.user?.data);

    const [customerId,setCustomerId] = useState("")
    const [companyProfile,setCompanyProfile] =  useState()

    useEffect(()=>{
      if(props?.getCustomerDetails){
        setCustomerId(props?.getCustomerDetails?.userId)
        setCompanyProfile(props?.getCustomerDetails?.companyProfile)
      }
    },[props])
    const availabilityOfSecurityChequeDropDown = [
      { id: 1, name: "Yes" },
      { id: 1, name: "No" },
    ];
    const PDCdetailsDropdown = [
      { id: 1, name: "Yes" },
      { id: 1, name: "No" },
    ];
    const [getCustomerData, setCustomerData] = useState();

    // const [getCustomer, setCustomer] = useState([]);

    // const [getCustomerDetails, setCustomerDetails] = useState(null);
    const [getCurrentAvailableAmt, setCurrentAvailableAmt] = useState(null);

    const [formInputs, setFormInputs] = useState({
      // creditLimitExceedCustomer: "",
      nextPaymentScheduleDate: "",
      nextPaymentScheduleAmount: "",
      PDCdetails: "",
      limitToExtendedDays: "",
      periodToExtendedAmount: "",
      currentOutstandingAmount: "",
      creditLimitAmount: "",
      currentPeriodDays: "",
      creditPeriodDays: "",
      availabilityOfSecurityCheque: "",
      salesOfficerName: "",
      salesOfficerCode: "",
      totalTurnover: "",
      periodToExtendedDays: "",
      limitToExtendedAmt: "",
    });
    const [creditLimitData, setcreditLimitData] = useState([
      {
        id: 1,
        name: "Limit",
        status: true,
      },
      {
        id: 2,
        name: "Period",
        status: false,
      },
    ]);
    const failureModalData = {
      title: "Warning",
      ErrorMsg: "",
    };

    const [editorContent, setEditorContent] = useState("");

    const [getFailureModal] = useState(failureModalData);

    const [validation, setValidation] = useState();
    const [getErrorFields, setErrorFields] = useState([]);
    const [getShowFailureModal, setShowFailureModal] = useState(false);
    const hideFailureModal = () => {
      setShowFailureModal(false);
    };

    const toggleCardVisibility1 = () => {
      setCardVisible1(!isCardVisible1);
    };
    const toggleCardVisibility2 = () => {
      setCardVisible2(!isCardVisible2);
    };

    useEffect(() => {
      setFormInputs({
        salesOfficerName: userData?.firstName || "",
        salesOfficerCode: userData?.userId || "",
        nextPaymentScheduleDate: getTodayDate(),
      });

      const handleEscapeKey = (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
          props.onHide();
        }
      };
      setCustomerData(props?.getCustomerDetails);
      setCurrentAvailableAmt(props?.currentAvailableAmt);
      document.addEventListener("keydown", handleEscapeKey);
      return () => {
        document.removeEventListener("keydown", handleEscapeKey);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const onInputChange = ({ target: { name, value } }) => {
      const errors = {};
      setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

      setValidation((prev) => ({
        ...prev,
        [name]: errors[name] || "",
      }));
      // console.log("onInputChange => formInputs", formInputs);
    };

    useEffect(() => {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setValidation((prev) => ({
        ...prev,
        [getDropdownData?.textField]: "",
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDropdownData]);

    //handle save
    const handleSave = async () => {
      formInputs.instruction = editorContent;
      formInputs.cpHeaderStatus = "Pending with L1";

      formInputs.customerName = getCustomerData?.organisationName;
      formInputs.address = getCustomerData?.address;
      formInputs.address2 = getCustomerData?.address2;
      formInputs.address3 = getCustomerData?.address3;
      formInputs.state = getCustomerData?.state;
      formInputs.cityPostalCode = getCustomerData?.cityPostalCode;
      formInputs.certifications = getCustomerData?.certifications;

      formInputs.creditLimitAmt =
        parseFloat(getCustomerData?.creditLimitAmt) || "";
      formInputs.creditOutStandingAmt =
        parseFloat(getCustomerData?.creditOutStandingAmt) || "";
      formInputs.creditAvailableAmt = parseFloat(getCurrentAvailableAmt) || "";
      formInputs.creditLimitExpiryDate =
        getCustomerData?.creditLimitExpiryDate || "";
      formInputs.creditPeriod = getCustomerData?.creditPeriod || "";
      formInputs.pendingOrderValue = getCustomerData?.pendingOrderValue;

      formInputs.salesOfficerCode = userData?.userId;
      formInputs.salesOfficerName = userData?.firstName;
      formInputs.salesOfficerEmail = userData?.email;
      formInputs.salesOfficerContactNr = userData?.contactNumber;

      formInputs.creditLimitData = creditLimitData;
      formInputs.customerId = customerId;
      formInputs.companyProfile = companyProfile;
      

      const requiredFields = [];

      if (!validateRequired(formInputs?.availabilityOfSecurityCheque)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          availabilityOfSecurityCheque: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs?.securityChequeAmount)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          securityChequeAmount: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs?.PDCdetails)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          PDCdetails: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs?.nextPaymentScheduleAmount)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          nextPaymentScheduleAmount: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs?.limitToExtendedAmt)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          limitToExtendedAmt: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs?.periodToExtendedDays)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          periodToExtendedDays: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      let obj = {
        data: formInputs,
      };

      // console.log(">>obj",obj)

      setDisabled(true);
      await ItemService.addCreditPolicy(obj).then((item) => {
        // console.log('>> item!',item);
        if (item?.status === 200) {
          toast.success(item?.message || "addCreditPolicy Order successfully", {
            duration: 2000,
            position: "top-right",
          });
          // props.onSuccess();
          props.onHide();
        } else {
          console.log(">> Error: Loading addCreditPolicy");
        }
        setDisabled(false);
      });
    };

    // This is for Text Editor
    const handleEditorChange = (content) => {
      setEditorContent(content);
    };
    //handle cancel modal
    const handleCancel = () => {
      props.onHide();
    };
    //handle check box
    const handleTermsConditionCheckBox = (id) => {
      // Update the status of the item based on its id
      const updatedData = creditLimitData.map((item) => {
        if (item.id === id) {
          return { ...item, status: !item.status };
        }
        return item;
      });
      // Update the state with the modified data
      setcreditLimitData(updatedData);
    };
    //Load Master Data
    // const getMasterData = async () => {
    //   let obj = {};
    //   await ItemService.getCustomers(obj).then((item) => {
    //     // console.log(">> item! title", item);
    //     if (item?.status === 200) {
    //       setCustomer(item?.data);
    //     } else {
    //       setCustomer([]);
    //       console.log(">> Error: Loading getCustomers");
    //     }
    //   });
    // };
    // useEffect(() => {
    //   getMasterData();
    // }, []);

    // Onselect of Country state will load
    // const getCustomerDetail = async (userId) => {
    //   let obj1 = {
    //     documentNumber: userId,
    //   };
    //   await ItemService.getCustomerDetail(obj1).then((item) => {
    //     // console.log(">> item!", item);
    //     if (item?.status === 200) {
    //       setCustomerDetails(item?.data[0] || null);
    //     } else {
    //       setCustomerDetails([]);
    //       console.log(">> Error: Loading getProjectName");
    //     }
    //   });
    // };
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Credit Policy Request {/* {getData?.documentNumber} */} 124
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <div
            // id="acc"
            className={`accordion-collapse collapse show ${
              isCardVisible1 ? "visible" : ""
            }`}
          >
            {/* 01 Basic Information */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Credit Policy Form</span>
                      <span className="subHeaderTitle">Credit Policy Form</span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          name="organisationName"
                          placeholder=""
                          value={getCustomerData?.organisationName || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>{" "}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Customer Address"
                          name="projectAddress"
                          value={[
                            getCustomerData?.address,
                            getCustomerData?.address2,
                            getCustomerData?.address3,
                            getCustomerData?.state,
                            getCustomerData?.cityPostalCode,
                          ]
                            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                            .join(" ")}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sales Officer Name"
                          name="salesOfficerName"
                          placeholder=""
                          value={formInputs?.salesOfficerName || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex gap-1 align-items-center"
                      >
                        {creditLimitData.map((item, i) => (
                          <div className="form-check" key={item.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`gridCheck${item.id}`}
                              checked={item.status}
                              onChange={() =>
                                handleTermsConditionCheckBox(item.id)
                              }
                              disabled={item?.disabled}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`gridCheck${item.id}`}
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Current Out Standing Amount"
                          name="creditOutStandingAmt"
                          placeholder=""
                          value={getCustomerData?.creditOutStandingAmt || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Limit Amount"
                          name="creditLimitAmt"
                          placeholder=""
                          value={getCustomerData?.creditLimitAmt || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Period (Days)"
                          id="creditPeriod"
                          name="creditPeriod"
                          value={getCustomerData?.creditPeriod}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Current Available Amt"
                          id="currentAvailableAmt"
                          name="currentAvailableAmt"
                          value={getCurrentAvailableAmt}
                          disabled={true}
                        />
                      </Col>
                      <Row>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Current Period Days"
                            name="currentPeriodDays"
                            placeholder=""
                            value={formInputs?.currentPeriodDays || ""}
                            onChange={onInputChange}
                            // disabled={getDisabledStatus}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Availability Of Security Cheque"
                            placeholder=""
                            data={availabilityOfSecurityChequeDropDown}
                            id="availabilityOfSecurityCheque"
                            iconClassName="dropdownIcon"
                            name="availabilityOfSecurityCheque"
                            // code="availabilityOfSecurityChequeCode"
                            // description="availabilityOfSecurityChequeDesc"
                            setValue={formInputs?.availabilityOfSecurityCheque}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation?.availabilityOfSecurityCheque}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Security Cheque Amount"
                            type="number"
                            name="securityChequeAmount"
                            placeholder=""
                            value={formInputs?.securityChequeAmount || ""}
                            onChange={onInputChange}
                            error={validation?.securityChequeAmount}

                            // disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="PDC Details"
                            placeholder=""
                            data={PDCdetailsDropdown}
                            id="PDCdetails"
                            iconClassName="dropdownIcon"
                            name="PDCdetails"
                            // code="PDCdetailsCode"
                            // description="PDCdetailsDesc"
                            setValue={formInputs?.PDCdetails}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation?.PDCdetails}

                            // error={validation.country}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Next Payment Schedule Amount"
                            type="number"
                            name="nextPaymentScheduleAmount"
                            placeholder=""
                            value={formInputs?.nextPaymentScheduleAmount || ""}
                            onChange={onInputChange}
                            error={validation?.nextPaymentScheduleAmount}

                            // disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Next Payment Schedule Date"
                            name="nextPaymentScheduleDate"
                            type="date"
                            placeholder=""
                            value={formInputs?.nextPaymentScheduleDate}
                            onChange={onInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="number"
                            label="Limit to be Extended (Amount)"
                            name="limitToExtendedAmt"
                            placeholder=""
                            value={formInputs?.limitToExtendedAmt || ""}
                            onChange={onInputChange}
                            error={validation?.limitToExtendedAmt}

                            // disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Period to be Extended (Days)"
                            type="number"
                            name="periodToExtendedDays"
                            placeholder=""
                            value={formInputs?.periodToExtendedDays || ""}
                            onChange={onInputChange}
                            error={validation?.periodToExtendedDays}

                            // disabled={getDisabledStatus}
                          />
                        </Col>

                        {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Total Turnover"
                          name="totalTurnover"
                          placeholder=""
                          value={formInputs?.totalTurnover || ""}
                          onChange={onInputChange}
                          // disabled={getDisabledStatus}
                        />
                      </Col> */}
                        <Col
                          lg={12}
                          className="commTopButtonRightLeftPadding d-flex"
                        >
                          Credit
                          <p>
                            <span className="fw-bold mx-2">
                              {creditLimitData[0]?.status && (
                                <>{creditLimitData[0]?.name}</>
                              )}{" "}
                              {creditLimitData[1]?.status && (
                                <> & {creditLimitData[1]?.name}</>
                              )}
                            </span>
                            {/* {creditLimitData
                          .filter((item) => item.status) // Filter items where status is true
                          .map((item) => (
                            <span className="fw-bold mx-2" key={item.id}>
                              {item.name},
                            </span> // Display only name of matched items
                          ))}                         */}
                            Exceed for the customer{" "}
                            <span className="fw-bold me-1">
                              {getCustomerData?.organisationName}
                            </span>
                            {/* <span className="fw-bold">
                          {formInputs.sapDocumentNumber}
                        </span> */}
                          </p>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*  02 */}
            {/* Instructions 03*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Instructions</span>
                      <span className="subHeaderTitle">
                        Instructions Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={editorContent}
                          onChange={handleEditorChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <Row className="mt-4">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end"
              >
                <button className="btnTable btn-danger" onClick={handleCancel}>
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={getdisabled}
                >
                  Save
                </button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />
      </Modal>
    );
  }
);

export default CreditPolicyRequestFormOrderBookingModal;
